import { render, staticRenderFns } from "./testPaperUs.vue?vue&type=template&id=7207f95d&"
import script from "./testPaperUs.vue?vue&type=script&lang=ts&"
export * from "./testPaperUs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports